import React from "react";
import Searchbar from "./Searchbar";

function Search({ handleInputChange }) {
    return <Searchbar handleInputChange={handleInputChange} />;
}

export default Search;